// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ec90daa8","952":"e564ac2f"}[chunkId] + ".chunk.js";
};